import Cookies from 'js-cookie';

interface LocationCookies {
  zip?: string;
  city?: string;
  state?: string;
}

export const getCookie = (name: string): string | undefined => {
  return Cookies.get(name);
};

export const setCookie = (name: string, value: string): void => {
  Cookies.set(name, value);
};

export const getLocationCookies = (): LocationCookies => ({
  zip: getCookie('CVCurrentZip'),
  city: getCookie('CVCurrentCity'),
  state: getCookie('CVCurrentState')
});

export const updateLocationCookies = (
  newLocation: LocationCookies
): boolean => {
  const currentLocation = getLocationCookies();
  let updated = false;

  if (newLocation.zip && newLocation.zip !== currentLocation.zip) {
    setCookie('CVCurrentZip', newLocation.zip);
    updated = true;
  }

  if (newLocation.city && newLocation.city !== currentLocation.city) {
    setCookie('CVCurrentCity', newLocation.city);
    updated = true;
  }

  if (newLocation.state && newLocation.state !== currentLocation.state) {
    setCookie('CVCurrentState', newLocation.state);
    updated = true;
  }

  return updated;
};
